import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'

const ReportCard = () => {
  const navigate = useNavigate()
  const [hoveredCard1, setHoveredCard1] = useState(false)
  const [hoveredCard2, setHoveredCard2] = useState(false)
  const [hoveredCard3, setHoveredCard3] = useState(false)

  const toNavigate = (id: any) => {
    if (id === 1) {
      navigate('/report/agent-dashboard')
    } else if (id === 2) {
      navigate('/report/supplier-dashboard')
    } else {
      navigate('/report/chatHistory-report')
    }
  }

  const cardStyle1 = {
    transition: 'transform 0.3s, box-shadow 0.3s',
    transform: hoveredCard1 ? 'translateY(-5px)' : 'none',
    boxShadow: hoveredCard1 ? '0 4px 20px rgba(0, 0, 0, 0.1)' : 'none'
  }

  const cardStyle2 = {
    transition: 'transform 0.3s, box-shadow 0.3s',
    transform: hoveredCard2 ? 'translateY(-5px)' : 'none',
    boxShadow: hoveredCard2 ? '0 4px 20px rgba(0, 0, 0, 0.1)' : 'none'
  }

  const cardStyle3 = {
    transition: 'transform 0.3s, box-shadow 0.3s',
    transform: hoveredCard3 ? 'translateY(-5px)' : 'none',
    boxShadow: hoveredCard3 ? '0 4px 20px rgba(0, 0, 0, 0.1)' : 'none'
  }

  return (
    <div className='row gy-0 gx-10'>
      <div className='col-xl-6'>
        {/* Agent Report */}
        <div
          className='card card-xl-stretch bg-body border-0 mb-5 mb-xl-0'
          style={cardStyle1}
          onMouseEnter={() => setHoveredCard1(true)}
          onMouseLeave={() => setHoveredCard1(false)}
          onClick={() => toNavigate(1)}
        >
          <div className='card-body d-flex flex-column flex-lg-row flex-stack p-lg-15'>
            {/* Info */}
            <div className='d-flex flex-column justify-content-center align-items-center align-items-lg-start me-10 text-center text-lg-start'>
              {/* Title */}
              <h3 className='fs-2hx line-height-lg mb-5'>
                <span className='fw-bold'>Agent Report</span>
              </h3>
              {/* Description */}
              <div className='fs-4 text-muted mb-7'>
                View detailed reports and analytics for agents.
              </div>
              {/* Button */}
              <button
                className='btn btn-success fw-semibold px-6 py-3'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_create_campaign'
              >
                View Reports
              </button>
            </div>
            {/* Illustration */}
            <img
              src='/media/illustrations/dozzy-1/19.png'
              alt=''
              className='mw-200px mw-lg-350px mt-lg-n10'
            />
          </div>
        </div>
      </div>
      <div className='col-xl-6'>
        {/* Supplier Report */}
        <div
          className='card card-xl-stretch bg-body border-0 mb-5 mb-xl-0'
          style={cardStyle2}
          onMouseEnter={() => setHoveredCard2(true)}
          onMouseLeave={() => setHoveredCard2(false)}
          onClick={() => toNavigate(2)}
        >
          <div className='card-body d-flex flex-column flex-lg-row flex-stack p-lg-15'>
            {/* Info */}
            <div className='d-flex flex-column justify-content-center align-items-center align-items-lg-start me-10 text-center text-lg-start'>
              {/* Title */}
              <h3 className='fs-2hx line-height-lg mb-5'>
                <span className='fw-bold'>Supplier Report</span>
              </h3>
              {/* Description */}
              <div className='fs-4 text-muted mb-7'>
                View detailed reports and analytics for suppliers.
              </div>
              {/* Button */}
              <button
                className='btn btn-success fw-semibold px-6 py-3'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_create_campaign'
              >
                View Reports
              </button>
            </div>
            {/* Illustration */}
            <img
              src='https://preview.keenthemes.com/metronic8/demo11/assets/media/illustrations/sketchy-1/11.png'
              alt=''
              className='mw-200px mw-lg-350px mt-lg-n10'
            />
          </div>
        </div>
      </div>
      <div className='col-xl-6 mt-6 mb-6'>
        {/* Supplier Report */}
        <div
          className='card card-xl-stretch bg-body border-0 mb-5 mb-xl-0'
          style={cardStyle3}
          onMouseEnter={() => setHoveredCard3(true)}
          onMouseLeave={() => setHoveredCard3(false)}
          onClick={() => toNavigate(3)}
        >
          <div className='card-body d-flex flex-column flex-lg-row flex-stack p-lg-15'>
            {/* Info */}
            <div className='d-flex flex-column justify-content-center align-items-center align-items-lg-start me-10 text-center text-lg-start'>
              {/* Title */}
              <h3 className='fs-2hx line-height-lg mb-5'>
                <span className='fw-bold'>Chat History Report</span>
              </h3>
              {/* Description */}
              <div className='fs-4 text-muted mb-7'>View detailed reports of Chat History.</div>
              {/* Button */}
              <button
                className='btn btn-success fw-semibold px-6 py-3'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_create_campaign'
              >
                View Reports
              </button>
            </div>
            {/* Illustration */}
            <img
              src='https://botgobucket.s3.ap-south-1.amazonaws.com/botgo/image.png'
              alt='icon'
              className='mw-200px mw-lg-350px mt-lg-n10'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportCard
